"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProofOfServiceStatus = void 0;
var ProofOfServiceStatus;
(function (ProofOfServiceStatus) {
    ProofOfServiceStatus["Created"] = "created";
    ProofOfServiceStatus["ReadyForBilling"] = "ready-for-billing";
    ProofOfServiceStatus["Billed"] = "billed";
    ProofOfServiceStatus["Clarifying"] = "clarifying";
    ProofOfServiceStatus["NotBillable"] = "not-billable";
})(ProofOfServiceStatus = exports.ProofOfServiceStatus || (exports.ProofOfServiceStatus = {}));
